module.exports = __webpack_public_path__ + "img/success.53b9de78.svg";